var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2px",
    height: "21px",
    viewBox: "0 0 2 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Line 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: 3,
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Referral",
    transform: "translate(-411.000000, -353.000000)",
    stroke: "#D2E3E4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inner--content",
    transform: "translate(330.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(51.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,58 L31,80.5",
    id: "Line-8"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnector);
export default __webpack_public_path__ + "static/media/connector.d120f62e7470f828f41eefec8a051935.svg";
export { ForwardRef as ReactComponent };